<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center" v-if="!resultado">
            <h3 class>Generación de nueva clave</h3>
            <!-- <div class="row form-group">
              <div class="col-md-12">
                <base-input
                  placeholder="Nueva clave"
                  class="input-group-alternative mb-3"
                  v-model="model.password"
                  type="password"
                ></base-input>
              </div>
            </div>-->

            <password-validator
              v-model="model.password"
              @password-validated="updatePasswordValidity"
              placeholder="Nueva clave"
            ></password-validator>

            <div class="row form-group">
              <div class="col-md-12">
                <base-input
                  placeholder="Confirmar nueva clave"
                  class="input-group-alternative mb-3"
                  v-model="model.confirmPassword"
                  type="password"
                  addon-left-icon="fa fa-fw fa-unlock-alt"
                ></base-input>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="login"
                  :disabled="model.passwordIsValid === false"
                >Cambiar clave</base-button>
              </div>
            </div>
          </div>

          <div class="text-center" v-if="resultado">
            <img src="@/assets/mail_verify.png" class="img-fluid" />
            <h3 class="rscolor">¡ Tu clave fue cambiada correctamente !</h3>Ya podés utilizarla para ingresar a la aplicacion
            <div>
              <a
                href="https://www.resimple.com.ar/"
                class="btn active btnVerify"
                role="button"
                aria-pressed="true"
              >Ir a resimple.com.ar</a>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </div>
  </div>
</template>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PasswordValidator from "@/components/Custom/PasswordValidator";

export default {
  components: { PasswordValidator },
  name: "login",
  data() {
    return {
      model: {
        password: "",
        confirmPassword: "",
        passwordIsValid: false
      },
      resultado: false,
      cargado: false
    };
  },
  methods: {
    updatePasswordValidity(isValid) {
      let context = this;
      context.model.passwordIsValid = isValid;
    },
    login() {
      let context = this;

      if (context.model.password != context.model.confirmPassword) {
        notificationHelpers.showError(
          "Advertencia!",
          "Los campos clave y repetir clave deben ser iguales",
          this
        );
        return;
      }

      axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/ChangePassword",
        {
          Code: context.$route.query.code,
          Password: this.model.password
        },
        this,
        function(data) {
          context.resultado = data.ResponseVM.Resultado;
          context.resultadoError = !context.resultado;
        }
      );
    }
  },
  beforeMount() {}
};
</script>

<style>
a {
  color: #ff4940;
}

a:hover {
  color: #c93961;
}

.btnVerify {
  background: rgba(255, 88, 85, 1);
  padding: 10px;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
  margin-bottom: 20px;
}

.btnVerify:hover {
  background: rgba(201, 57, 98, 1);
  color: #fff;
  text-decoration: none;
}

.rscolor {
  color: #ff4940;
}
h1,
h2,
h3,
h4,
h5 {
  color: #ff4940;
}

a {
  color: #ff4940;
}

a:hover {
  color: #c93961;
}

.tcpanel {
  padding: 20px;
  background-color: #f9f9f9;
}

.rscolor {
  color: #ff4940;
}

.footer {
  background-color: #f5f5f5;
}

main {
  margin-top: 60px;
}

.logo {
  max-height: 40px;
}

.rsgradient {
  background: rgba(255, 88, 85, 1);
  background: -moz-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(255, 88, 85, 1)),
    color-stop(100%, rgba(201, 57, 98, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff5855', endColorstr='#c93962', GradientType=0 );
}
</style>
